import { Box, FormControl, Grid, InputLabel, TextField, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import React from 'react';
import { Divider } from '@mui/material';
import { useTranslation } from '../../../commons/useTranslasion';
import { esES, ptBR } from '@mui/material/locale';


interface Props {
  novoUsuario: boolean;
}

const PPCStepper4: React.FC<Props> = (props: Props) => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  const { novoUsuario } = props;
  const methods = useFormContext();

  const handleAutoSave = () => {
    document.getElementById('btnSavePPC')?.click();
  };

  return (
    <>
      <Grid container xs={12} md={12} sm={12} sx={{
        display: "flex",
        flexWrap: "wrap",
        width: "100%",
      }}>
        <Grid xs={12} md={12} sm={12}>
          <Typography sx={{ padding: "10px 0px" }} variant="h5" component="h2">
            {translate('historicoDeCarreira')}
          </Typography>
        </Grid>

        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            <b>{translate('historicoDeCarreiraSubTitulo')}</b>
          </Typography>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate('historicoDeCarreiraSubTituloTexto1')}
          </Typography>
        </Grid>


        <Grid container xs={12} md={12} sx={{ display: "flex" }}>
          <Typography sx={{ padding: "5px 0px" }} variant="caption">
            <b>{translate('pontosFortesTitulo')}:</b>
          </Typography>

          <Grid container xs={12} md={12} sx={{ padding: "0px 50px", paddingBottom: "5px", display: "flex" }}>
            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP1")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP1'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP2")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP2'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP3")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP3'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP4")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP4'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP5")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP5'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP6")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP6'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFortesP7")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotForteP7'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate("pontosFortesDescricao")}

            {translate("pontosFortesDescricao2")}
          </Typography>
        </Grid>

        <Grid container xs={12} md={12} sx={{ display: "flex" }}>
          <Typography sx={{ padding: "5px 0px" }} variant="caption">
            <b>{translate("pontosFracosTitulo")}:</b>
          </Typography>

          <Grid container xs={12} md={12} sx={{ padding: "0px 50px", paddingBottom: "5px", display: "flex" }}>
            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP1")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP1'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP2")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP2'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP3")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP3'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP4")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP4'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP5")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP5'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP6")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP6'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP7")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP7'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("pontosFracosP8")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotFracoP8'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate("pontosFracosDescricao")}
          </Typography>
        </Grid>

        <Grid container xs={12} md={12} sx={{ display: "flex" }}>
          <Typography sx={{ padding: "5px 0px" }} variant="caption">
            <b>{translate("oportunidadesTitulo")}:</b>
          </Typography>

          <Grid container xs={12} md={12} sx={{ padding: "0px 50px", paddingBottom: "5px", display: "flex" }}>
            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("oportunidadesP1")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotOportunidadeP1'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("oportunidadesP2")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotOportunidadeP2'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("oportunidadesP3")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotOportunidadeP3'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("oportunidadesP4")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotOportunidadeP4'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("oportunidadesP5")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotOportunidadeP5'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

          </Grid>
        </Grid>

        <Grid container xs={12} md={12} sx={{ display: "flex" }}>
          <Typography sx={{ padding: "5px 0px" }} variant="caption">
            <b>{translate("ameacasTitulo")}:</b>
          </Typography>

          <Grid container xs={12} md={12} sx={{ padding: "0px 50px", paddingBottom: "5px", display: "flex" }}>
            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP1")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP1'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP2")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP2'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP3")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP3'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP4")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP4'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP5")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP5'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

            <Grid xs={12} md={12} sm={12} sx={{ paddingBottom: "5px", width: "100%", marginTop: "10px" }}>
              <InputLabel sx={{
                whiteSpace: "normal"
              }}>
                {translate("ameacasP6")}
              </InputLabel >
              <Controller
                control={methods.control}
                name='analiseSwotAmeacaP6'
                render={({ field: { ref, ...field } }) => (
                  <TextField sx={{ width: "100%" }}
                    id="standard-basic"
                    {...field}
                    inputRef={ref}
                    value={field.value}
                    label=""
                    variant="standard"
                    multiline
                    maxRows={4}
                    onBlur={handleAutoSave}
                  />
                )}
              />
            </Grid>

          </Grid>
        </Grid>

        <Grid container xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Typography sx={{ padding: "10px" }} variant="caption">
            {translate("ameacasDescricao")}

            {translate("ameacasDescricao1")}
          </Typography>
        </Grid>

        <Grid container direction="row" xs={12} md={12} sx={{ paddingBottom: "10px", display: "flex" }}>
          <Divider orientation="horizontal" />

          <Grid container xs={12} md={12} sm={12} sx={{ display: "flex" }}>
            <Grid container xs={6} md={6} sm={6} sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              color: "#4299e7",
              padding: "10px 5px 15px 5px",
              borderTop: "1px solid #4299e7",
              fontWeight: "500"
            }}>
              {translate("util")}

            </Grid>
            <Grid container xs={6} md={6} sm={6} sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              color: "#d90000",
              padding: "10px 5px 15px 5px",
              borderTop: "1px solid #d90000",
              fontWeight: "500"
            }}>
              {translate("prejudicial")}
            </Grid>
          </Grid>

          <Grid container xs={12} md={12} sm={12} sx={{ display: "flex" }}>
            <Grid container xs={6} md={6} sm={6} sx={{ display: "flex" }}>
              <Grid container xs={12} md={12} sm={12} sx={{
                display: "flex",
                textAlign: "center",
                paddingBottom: "10px",
                backgroundColor: "#588bff",
                color: "white",
                borderRadius: "5px",
                padding: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
                margin: "0px 10px 10px 10px"
              }}>
                {translate("forcas")}
              </Grid>
              <Grid container xs={12} md={12} sm={12} sx={{ display: "flex", padding: "10px" }}>
                <Controller
                  control={methods.control}
                  name='analiseSwotForcaOrigem'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      id="standard-multiline-static"
                      {...field}
                      inputRef={ref}
                      value={field.value}
                      label="Origem Interna"
                      multiline
                      rows={4}
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onBlur={handleAutoSave}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container xs={6} md={6} sm={6} sx={{ display: "flex" }}>
              <Grid container xs={12} md={12} sm={12} sx={{
                display: "flex",
                textAlign: "center",
                paddingBottom: "10px",
                backgroundColor: "#f75f25",
                color: "white",
                borderRadius: "5px",
                padding: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
                margin: "0px 10px 10px 10px"
              }}>
                {translate("fraquezas")}
              </Grid>
              <Grid container xs={12} md={12} sm={12} sx={{ display: "flex", padding: "10px" }}>
                <Controller
                  control={methods.control}
                  name='analiseSwotOportunidadeOrigem'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      id="standard-multiline-static"
                      {...field}
                      inputRef={ref}
                      value={field.value}
                      label="Origem Interna"
                      multiline
                      rows={4}
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onBlur={handleAutoSave}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container xs={12} md={12} sm={12} sx={{ display: "flex" }}>
            <Grid container xs={6} md={6} sm={6} sx={{ display: "flex" }}>
              <Grid container xs={12} md={12} sm={12} sx={{
                display: "flex",
                textAlign: "center",
                paddingBottom: "10px",
                backgroundColor: "#4dbd29",
                color: "white",
                borderRadius: "5px",
                padding: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
                margin: "0px 10px 10px 10px"
              }}>
                {translate("oportunidades")}
              </Grid>
              <Grid container xs={12} md={12} sm={12} sx={{ display: "flex", padding: "10px" }}>
                <Controller
                  control={methods.control}
                  name='analiseSwotFraquezaOrigem'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      id="standard-multiline-static"
                      {...field}
                      inputRef={ref}
                      value={field.value}
                      label="Origem Externa"
                      multiline
                      rows={4}
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onBlur={handleAutoSave}
                    />
                  )}
                />
              </Grid>
            </Grid>

            <Grid container xs={6} md={6} sm={6} sx={{ display: "flex" }}>
              <Grid container xs={12} md={12} sm={12} sx={{
                display: "flex",
                textAlign: "center",
                paddingBottom: "10px",
                backgroundColor: "#ffb329",
                color: "white",
                borderRadius: "5px",
                padding: "10px",
                flexWrap: "wrap",
                justifyContent: "center",
                margin: "0px 10px 10px 10px"
              }}>
                {translate("ameacas")}
              </Grid>
              <Grid container xs={12} md={12} sm={12} sx={{ display: "flex", padding: "10px" }}>
                <Controller
                  control={methods.control}
                  name='analiseSwotAmeacaOrigem'
                  render={({ field: { ref, ...field } }) => (
                    <TextField
                      id="standard-multiline-static"
                      {...field}
                      inputRef={ref}
                      value={field.value}
                      label="Origem Externa"
                      multiline
                      rows={4}
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onBlur={handleAutoSave}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Grid>


        </Grid>

      </Grid >
    </>
  );
};

export default PPCStepper4;
